import React from "react";
import { SegmentedControl } from "../../../components/ui";

// agent-experience-redesign-v1.md §4.3 — comfortable / compact toggle.
// 96px tile (comfortable) vs 64px tile (compact). Persisted to
// localStorage; default = comfortable, auto-flips to compact when the
// tenant has > 50 agents (parent decides; toggle is just the UI).
//
// Renders via the shared SegmentedControl primitive so this stays
// visually identical to ViewModeToggle and any future toggle group.

const STORE_KEY = "library.density";

export function readDensity() {
  try { return localStorage.getItem(STORE_KEY) || "comfortable"; } catch { return "comfortable"; }
}
export function writeDensity(d) {
  try { localStorage.setItem(STORE_KEY, d); } catch {}
}

const OPTIONS = [
  { value: "comfortable", label: "Comfy",   title: "Comfortable density (96px tiles)" },
  { value: "compact",     label: "Compact", title: "Compact density (64px tiles)"     },
];

export default function DensityToggle({ density, onChange }) {
  return (
    <SegmentedControl
      value={density}
      onChange={(next) => { writeDensity(next); onChange(next); }}
      options={OPTIONS}
    />
  );
}
